import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import { EXTERNAL_PATHS } from '../../constants';
import Icon from '../Icon';
import UniversalLink from '../UniversalLink';

import styles from './InquiryBanner.module.scss';

export type InquiryBannerProps = {
  threadId?: string;
  variant:
  | 'desktop'
  | 'drawer'
  /** @deprecated */
  | 'sheet';
  hide?: boolean;
};

const InquiryBanner: FC<InquiryBannerProps> = ({ threadId, variant, hide }) => {
  const [t] = useTranslation('common');

  if (!threadId) return null;

  return (
    <div className={getClassNames(styles, 'root', classNames(`variant-${variant}`, { hide }))}>
      <Icon
        id="common/exclamation"
        className={styles.icon}
      />
      <p className={styles.text}>{t('inquiry-banner--text')}</p>
      <UniversalLink
        href={`${EXTERNAL_PATHS.INBOX}${threadId}/`}
        className={styles.link}
      >
        {t('inquiry-banner--link')}
      </UniversalLink>
    </div>
  );
};

export default InquiryBanner;
